"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.posOrderItemsAdapter = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var big_numbers_1 = require("../../../utils/big-numbers");
var types_1 = require("../types");
var customizations_1 = require("./customizations");
var items_processor_1 = require("./items-processor");
var mapper_1 = require("./mapper");
var pos_items_preprocessor_1 = require("./pos-items-preprocessor");
function generateCustomizationApplyScopeId(orderItem, parentIndex, index) {
    return "".concat(parentIndex, "-").concat(index, "-").concat(orderItem.customizationProductSourceId);
}
var posItemsAdapterV1 = function (orderItems, digitsRange) {
    return orderItems
        .map(pos_items_preprocessor_1.enrichPosOrderItems)
        .filter(function (orderItem) { return (0, pos_items_preprocessor_1.filterForOrderItems)(orderItem); })
        .reduce(function (extractedProducts, orderItem) {
        var totalPriceWithTaxIncluded = orderItem.totalPriceWithTaxIncluded, quantity = orderItem.quantity, _a = orderItem.customizations, customizations = _a === void 0 ? [] : _a;
        var itemUnitPrice = new bignumber_js_1.default(totalPriceWithTaxIncluded).dividedBy(quantity).shiftedBy(digitsRange);
        var originalUnitPrice = new bignumber_js_1.default(orderItem.originalUnitPrice).shiftedBy(digitsRange);
        var customizationsTotalAmount = big_numbers_1.big0;
        var preprocessedcustomisations = (0, customizations_1.preprocessCustomizations)(customizations, digitsRange).map(function (customization) {
            var customizationProductSourceId = customization.customizationProductSourceId, customizationQuantity = customization.customizationQuantity, customizationTax = customization.customizationTax, preprocessedTotalPrice = customization.preprocessedTotalPrice, customizationValue = customization.customizationValue;
            itemUnitPrice = itemUnitPrice.minus(preprocessedTotalPrice);
            customizationsTotalAmount = customizationsTotalAmount.plus(preprocessedTotalPrice);
            return {
                id: customizationProductSourceId,
                depth: 1,
                quantity: new bignumber_js_1.default(customizationQuantity).multipliedBy(quantity).toNumber(),
                label: customizationValue,
                taxRate: new bignumber_js_1.default(customizationTax).shiftedBy(4).integerValue().toNumber(),
                applyScopeId: generateCustomizationApplyScopeId(customization, orderItem.index, customization.index),
                amount: new bignumber_js_1.default(preprocessedTotalPrice).multipliedBy(quantity),
                additionalData: customization,
            };
        });
        var discountedAmount = originalUnitPrice
            .plus(customizationsTotalAmount)
            .multipliedBy(quantity)
            .minus(new bignumber_js_1.default(orderItem.itemDiscount || 0).shiftedBy(digitsRange))
            .integerValue();
        var bigNumberAmount;
        if (discountedAmount.lt(0)) {
            bigNumberAmount = discountedAmount;
        }
        else if (originalUnitPrice.isGreaterThan(itemUnitPrice)) {
            bigNumberAmount = originalUnitPrice.multipliedBy(quantity);
        }
        else {
            bigNumberAmount = itemUnitPrice.multipliedBy(quantity);
        }
        var amount = bigNumberAmount.integerValue();
        extractedProducts = __spreadArray(__spreadArray(__spreadArray([], extractedProducts, true), [
            (0, mapper_1.posOrderItemToOrderDetailProductMapper)(orderItem, amount)
        ], false), preprocessedcustomisations, true);
        return extractedProducts;
    }, []);
};
var posItemsAdapterV2 = function (orderItems, digitsRange) {
    return orderItems
        .map(pos_items_preprocessor_1.enrichPosOrderItems)
        .filter(function (orderItem) { return (0, pos_items_preprocessor_1.filterForOrderItems)(orderItem); })
        .reduce(function (extractedProducts, orderItem) {
        var totalPriceWithTaxIncluded = orderItem.totalPriceWithTaxIncluded, quantity = orderItem.quantity, _a = orderItem.customizations, customizations = _a === void 0 ? [] : _a;
        var itemUnitPrice = new bignumber_js_1.default(totalPriceWithTaxIncluded).dividedBy(quantity).shiftedBy(digitsRange);
        var originalUnitPrice = new bignumber_js_1.default(orderItem.originalUnitPrice).shiftedBy(digitsRange);
        var customizationsTotalAmount = big_numbers_1.big0;
        var preprocessedcustomisations = (0, customizations_1.preprocessCustomizations)(customizations, digitsRange).map(function (customization) {
            var customizationProductSourceId = customization.customizationProductSourceId, customizationQuantity = customization.customizationQuantity, customizationTax = customization.customizationTax, preprocessedTotalPrice = customization.preprocessedTotalPrice, customizationValue = customization.customizationValue;
            itemUnitPrice = itemUnitPrice.minus(preprocessedTotalPrice);
            customizationsTotalAmount = customizationsTotalAmount.plus(preprocessedTotalPrice);
            return {
                id: customizationProductSourceId,
                depth: 1,
                quantity: new bignumber_js_1.default(customizationQuantity).multipliedBy(quantity).toNumber(),
                label: customizationValue,
                taxRate: new bignumber_js_1.default(customizationTax).shiftedBy(4).integerValue().toNumber(),
                applyScopeId: generateCustomizationApplyScopeId(customization, orderItem.index, customization.index),
                amount: new bignumber_js_1.default(preprocessedTotalPrice).multipliedBy(quantity),
                additionalData: customization,
            };
        });
        var discountedAmount = originalUnitPrice
            .plus(customizationsTotalAmount)
            .multipliedBy(quantity)
            .minus(new bignumber_js_1.default(orderItem.itemDiscount || 0).shiftedBy(digitsRange))
            .integerValue();
        var bigNumberAmount;
        if (discountedAmount.lt(0)) {
            bigNumberAmount = discountedAmount;
        }
        else if (originalUnitPrice.isGreaterThan(itemUnitPrice)) {
            bigNumberAmount = originalUnitPrice.multipliedBy(quantity);
        }
        else {
            bigNumberAmount = itemUnitPrice.multipliedBy(quantity);
        }
        var amount = bigNumberAmount.integerValue();
        extractedProducts = __spreadArray(__spreadArray(__spreadArray([], extractedProducts, true), [
            (0, mapper_1.posOrderItemToOrderDetailProductMapper)(orderItem, amount)
        ], false), preprocessedcustomisations, true);
        return extractedProducts;
    }, []);
};
var posItemsAdapterV3 = function (orderItems, digitsRange) {
    var preprocessedItems = new pos_items_preprocessor_1.PosItemsPreprocessor(orderItems).getPreprocessedItems();
    var processedItems = (0, items_processor_1.processItems)({ preprocessedItems: preprocessedItems, digitsRange: digitsRange }).processedItems;
    return processedItems;
};
function posOrderItemsAdapter(_a, digitsRange, posApiVersion) {
    var _b = _a.orderItems, orderItems = _b === void 0 ? [] : _b;
    switch (posApiVersion) {
        case types_1.PosOrderApiVersion.V1: {
            return posItemsAdapterV1(orderItems, digitsRange);
        }
        case types_1.PosOrderApiVersion.V2: {
            return posItemsAdapterV2(orderItems, digitsRange);
        }
        case types_1.PosOrderApiVersion.V5:
        case types_1.PosOrderApiVersion.V4:
        case types_1.PosOrderApiVersion.V3: {
            return posItemsAdapterV3(orderItems, digitsRange);
        }
        default:
            throw new Error('posApiVersion must be a PosOrderApiVersion value');
    }
}
exports.posOrderItemsAdapter = posOrderItemsAdapter;
